import React from 'react';
import { Users } from 'lucide-react';
import { TeamActivityFeed } from '../components/collaboration/TeamActivityFeed';
import { TeamMembersWhoExplored } from '../components/team-widgets/TeamMembersWhoExplored';

export const TeamExplorationLab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-3">
          <Users className="h-8 w-8 text-consulting-slate-blue-600" />
          <h1 className="text-3xl font-bold text-charcoal-900">Team Exploration (Lab)</h1>
        </div>
        <p className="text-charcoal-600 text-sm">Aggregate view of team members exploring models and recent activity.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-[var(--bg-raised)] border border-charcoal-200 p-4">
          <h2 className="text-lg font-semibold text-charcoal-900 mb-3">Who’s Exploring</h2>
          <TeamMembersWhoExplored frameworkId={''} frameworkName={''} maxDisplay={12} />
        </div>
        <div className="bg-[var(--bg-raised)] border border-charcoal-200 p-4">
          <h2 className="text-lg font-semibold text-charcoal-900 mb-3">Recent Team Activity</h2>
          <TeamActivityFeed />
        </div>
      </div>
    </div>
  );
};


